import { UserManagerSettings } from 'oidc-client';
import { AuthServiceBase } from '@gis/common';

//https://docs.secureappfabric.de/display/SECDEVDOC/5.+Authentifizierung+mit+dem+.secure-IdentityServer
class AuthService extends AuthServiceBase {
    configure(): UserManagerSettings {
        const settings = this.createDefaultUserManagerSettings(
            process.env.VUE_APP_IDENTITY_SERVER_URL,
            process.env.VUE_APP_IDENTITY_SERVER_CLIENT_ID,
            'openid profile microservice_api roles'
        );
        return settings;
    }

    protected setDefaults(bindEvents: boolean): void {
        super.setDefaults(bindEvents);
    }
}

export default new AuthService();